import { User } from "../users/user";
import { Workspace } from "../workspace/workspace";
import { WorkspaceRoleSchema, WorkspaceSeatType, } from "../workspace/workspace-role";
import { z } from "zod";
/**
 * Object describing who is going to receive the email.
 *
 * Normally recepient is just an email, however in some cases email can be tailored
 * for who receives it. In this case the email has cutomization based on the role of the
 * recepient in the workspace.
 */
export const WorkspaceInviteEmailRecipient = z.object({
    email: z.string(),
    role: WorkspaceRoleSchema,
    seatType: WorkspaceSeatType,
    isDeveloperInvite: z.boolean().optional(),
});
/**
 * Object describing the necessary data to send an email notifying a user that
 * they've been added to a workspace.
 */
export const WorkspaceInviteEmailData = z.object({
    workspace: Workspace,
    invitedBy: User,
    documentationDomain: z.string().optional(),
    designSystemName: z.string().optional(),
});
